import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export function NoteImageBlock({ fileId, alt }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!fileId) return undefined;
    let cancelled = false;
    let objectUrl;

    (async () => {
      try {
        const { data } = await api.get(`/portal/files/item/${fileId}/download`, {
          responseType: "blob",
        });
        if (cancelled) return;
        objectUrl = URL.createObjectURL(data);
        setSrc(objectUrl);
        setFailed(false);
      } catch {
        if (!cancelled) setFailed(true);
      }
    })();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileId]);

  if (failed) {
    return (
      <div className="rounded-[var(--t-event-pill-radius)] border border-dashed border-[var(--t-border)] px-4 py-8 text-center text-sm text-[var(--t-meta)]">
        Could not load image
      </div>
    );
  }

  if (!src) {
    return (
      <div className="rounded-[var(--t-event-pill-radius)] border border-[var(--t-border)] px-4 py-8 text-center text-sm text-[var(--t-meta)]">
        Loading image…
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt || "Note image"}
      className="max-w-full rounded-[var(--t-event-pill-radius)] border border-[var(--t-border)] bg-white"
      data-testid="note-block-image"
    />
  );
}
